<template>
  <div class='plk_import'>
    <Menu></Menu>
    <div class='import'>
      <h5>{{$t('designer.import.titlepage')}}</h5>
      <Uploader acceptType="image/png,image/gif,image/svg+xml,image/jpeg,text/html,application/json,text/css,text/javascript" @loadFile="uploadFile"></Uploader>
      <div class="row">
        <div class="two ml-3 item" :title="$t('designer.import.listfiles.createemptyfile')">
          <div class="filecontainer">
            <div class="icon pointer" @click="createFile()">
              <i class="fas fa-file-medical"></i>
            </div>
          </div>
        </div>
        <div class="two ml-3 item" :class="{ 'editing': editImage === file }" v-for="(file, index) in files" :key="index" :title="file">
          <i v-if="editImage !== file" @click.stop="editImage = file" class="pointer edit fas fa-edit p-2 fa-edit" :title="$t('designer.import.listfiles.edit')"></i>
          <i v-if="editImage === file" @click.stop="$refs[`submitRename${index}`][0].click()" class="pointer edit fas fa-edit p-2 fa-save" :title="$t('designer.import.listfiles.save')"></i>
          <i @click.stop="copyFile(file)" class="pointer copy fas fa-copy p-2 mt-5" :title="$t('designer.import.listfiles.edit')"></i>
          <i @click.stop="deleteImage(file)" class="pointer remove fas fa-trash-alt p-2 mt-10" :title="$t('designer.import.listfiles.delete')"></i>
          <div class="filecontainer">
            <img v-if="getContent(file).isImage" :src="getContent(file).data" @click="openNewTabImage(file)" class="pointer file">
            <div class="icon pointer" v-if="!getContent(file).isImage" @click="editFile(file)">
              <i :class="{
                'fab fa-js-square': getContent(file).isJavascript,
                'fab fa-css3-alt': getContent(file).isCSS,
                'fas fa-file-code': getContent(file).isJSON,
                'fab fa-html5': getContent(file).isHtml,
                'fas fa-file-invoice': !getContent(file).isJavascript && !getContent(file).isCSS && !getContent(file).isJSON && !getContent(file).isHtml
              }"></i>
            </div>
            <div class="middle">
              <div class="text" v-if="editImage !== file">
                {{file}}
              </div>
              <form class="mb-0 pb-0" @submit.prevent="editImage = undefined; renameFile(file, renameFileParam[file])" v-else>
                <input required pattern="[/\\A-ZÑa-zñ_\-\.]+\.[A-Za-z]{2,5}" class="u-full-width mb-0 pb-0" type="text" v-model="renameFileParam[file]"/>
                <button :ref="`submitRename${index}`" type="submit" class="d-none"></button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { DESIGN } from '@/store'
import i18n from './i18n'
import { v4 as uuidv4 } from 'uuid'
import Uploader from './components/Uploader/Uploader'
import Menu from './components/Menu/Menu'
import { VIEWS } from '@/router/design'

export default {
  name: 'files',
  components: {
    Menu,
    Uploader
  },
  data () {
    return {
      fileName: '',
      isLoading: false,
      editImage: undefined,
      renameFileParam: {}
    }
  },
  computed: {
    connections () {
      return JSON.stringify(this.$store.getters[DESIGN.GETTERS.GET_CONNECTIONS]() || [], null, 2)
    },
    files () {
      return this.$store.getters[DESIGN.GETTERS.GET_ALL_FILES]()
    },
    styles () {
      return this.$store.getters[DESIGN.GETTERS.GET_STYLE]()
    },
    colors () {
      return this.$store.getters[DESIGN.GETTERS.GET_COLORS]()
    },
    javascript () {
      return this.$store.getters[DESIGN.GETTERS.GET_JAVASCRIPT]()
    },
    views () {
      return this.$store.getters[DESIGN.GETTERS.GET_VIEWS]()
    }
  },
  methods: {
    onInitComponent () {
      this.$servicesPLK.translation.init(i18n, { overwrite: false })
      this.loadFileToRename()
    },
    loadFileToRename () {
      Vue.set(this, 'renameFileParam', {})
      this.files.forEach((file) => { Vue.set(this.renameFileParam, file, file) })
    },
    uploadFile ({ filename, content }) {
      if (filename && content) {
        this.$store.commit({
          type: DESIGN.MUTATIONS.CREATE_FILE,
          filename,
          content
        })
      }
    },
    deleteImage (filename) {
      if (filename) {
        this.$modal.show('dialog', {
          title: this.$t('designer.import.listfiles.deletefile.title'),
          text: this.$t('designer.import.listfiles.deletefile.text', { name: filename }),
          buttons: [
            {
              title: this.$t('designer.import.listfiles.deletefile.modal.cancel'),
              handler: () => {
                this.$modal.hide('dialog')
              }
            },
            {
              title: this.$t('designer.import.listfiles.deletefile.modal.confirm'),
              handler: () => {
                this.$store.commit({
                  type: DESIGN.MUTATIONS.DELETE_FILE,
                  filename
                })
                this.$modal.hide('dialog')
              }
            }
          ]
        })
      }
    },
    renameFile (oldPath, newPath) {
      if (oldPath && newPath) {
        this.$store.commit({
          type: DESIGN.MUTATIONS.RENAME_FILE,
          oldPath,
          newPath
        })
      }
    },
    copyFile (filename) {
      if (filename) {
        const content = this.getContent(filename)
        this.uploadFile({ filename: `${uuidv4()}_${filename}`, content })
      }
    },
    getContent (filename) {
      return this.$store.getters[DESIGN.GETTERS.GET_FILE_CONTENT](filename)
    },
    openNewTabImage (filename) {
      let image = new Image()
      image.src = this.getContent(filename).data
      let w = window.open('', '_blank')
      w.document.write(image.outerHTML)
    },
    editFile (file) {
      this.$router.push({
        name: VIEWS.FILE_EDITOR.name,
        query: { file }
      })
    },
    createFile () {
      this.$modal.show(
        {
          template: `
            <div class="dialog-create">
              <form @submit.prevent="confirm" class="m-0">
                <div class="dialog-content">
                  <div class="vue-dialog-content-title">{{title}}</div>
                  <div>{{text}}</div>
                  <input pattern="[/\\\\A-ZÑa-zñ_\\-\\.]+\\.[A-Za-z]{2,5}" v-model="filename" required class="u-full-width mt-3" type="text" placeholder="file.txt" id="fileName">
                </div>
                <div class="vue-dialog-buttons">
                  <button type="button" @click="cancel" class="vue-dialog-button" style="flex: 1 1 50%;">
                    {{$t('designer.import.listfiles.createfile.modal.cancel')}}
                  </button>
                  <button type="submit" class="vue-dialog-button" style="flex: 1 1 50%;">
                    {{$t('designer.import.listfiles.createfile.modal.confirm')}}
                  </button>
                </div>
              </form>
            </div>
          `,
          props: ['name', 'title', 'text', 'onConfirm'],
          data () {
            return {
              filename: ''
            }
          },
          methods: {
            confirm () {
              if (this.onConfirm) this.onConfirm(this.filename)
            },
            cancel () {
              this.$emit('close')
            }
          }
        },
        {
          text: this.$t('designer.import.listfiles.createfile.text'),
          title: this.$t('designer.import.listfiles.createfile.title'),
          name: 'createFile',
          onConfirm: (filename) => {
            this.$store.commit({
              type: DESIGN.MUTATIONS.CREATE_FILE,
              filename,
              content: {
                data: '',
                base64Data: '',
                isImage: (/\.(gif|jpe?g|tiff?|png|webp|bmp)$/i).test(filename),
                isHtml: (/\.(html)$/i).test(filename),
                isJavascript: (/\.(js)$/i).test(filename),
                isJSON: (/\.(json)$/i).test(filename),
                isCSS: (/\.(css|scss)$/i).test(filename)
              }
            })
            this.$modal.hideAll()
          }
        },
        { height: 'auto', draggable: true, adaptive: true, class: 'vue-dialog' }
      )
    }
  },
  watch: {
    files () {
      this.loadFileToRename()
    }
  }
}
</script>
<style lang="scss">
  .dialog-create {
    .dialog-content {
      padding: 2rem;
    }
  }
</style>
<style scoped lang='scss'>
  @import '@/assets/styles/designcolor.scss';
  .plk_import {
    .mt-10 {
      margin-top: 6rem !important;
    }
    .import {
      padding: 3vh;
      padding-left: calc(3vh + 50px);

      .item {
        .file {
          opacity: 1;
          display: block;
          width: 100%;
          height: auto;
          transition: .5s ease;
          backface-visibility: hidden;
        }
        .middle {
          transition: .5s ease;
          opacity: 0;
          width: 100%;
          text-align: left;
          .text {
            overflow-y: hidden;
            overflow-x: scroll;
            white-space: nowrap;
            height: 40px;
            text-align: center;
          }
        }
        .filecontainer {
          .icon {
            text-align: center;
            font-size: 6vw;
          }
          &:hover {
            .file {
              opacity: 0.3;
            }
            .middle {
              opacity: 1;
            }
          }
        }
        img {
          border-radius: 5px;
          max-width: 100%;
        }
        .copy,
        .remove,
        .edit {
          position: absolute;
          z-index: 99;
          border-radius: 0% 25% 25% 0%;
          background: white;
          display: none;
          color: #bb1414;
        }
        .edit {
          color: green;
        }
        .copy {
          color: cadetblue;
        }
      }
      .item.editing {
        .file {
          opacity: 0.3;
        }
        .middle {
          opacity: 1;
        }
      }
      .item.editing .copy,
      .item.editing .remove,
      .item.editing .edit,
      .item:hover .copy,
      .item:hover .remove,
      .item:hover .edit{
        display: inline;
      }
    }
  }
</style>
